import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Routes, CanActivate } from '@angular/router';

import { UserRouteAccessService } from '../../shared';
import { PaginationUtil } from 'ng-jhipster';

import { ContactTempComponent } from './contact-temp.component';
import { ContactTempDetailComponent } from './contact-temp-detail.component';
import { ContactTempPopupComponent } from './contact-temp-dialog.component';
import { ContactTempDeletePopupComponent } from './contact-temp-delete-dialog.component';

import { Principal } from '../../shared';

@Injectable()
export class ContactTempResolvePagingParams implements Resolve<any> {

  constructor(private paginationUtil: PaginationUtil) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
      const page = route.queryParams['page'] ? route.queryParams['page'] : '1';
      const sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'id,asc';
      return {
          page: this.paginationUtil.parsePage(page),
          predicate: this.paginationUtil.parsePredicate(sort),
          ascending: this.paginationUtil.parseAscending(sort)
    };
  }
}

export const contactTempRoute: Routes = [
  {
    path: 'contact-temp',
    component: ContactTempComponent,
    resolve: {
      'pagingParams': ContactTempResolvePagingParams
    },
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.contactTemp.home.title'
    },
    canActivate: [UserRouteAccessService]
  }, {
    path: 'contact-temp/:id',
    component: ContactTempDetailComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.contactTemp.home.title'
    },
    canActivate: [UserRouteAccessService]
  }
];

export const contactTempPopupRoute: Routes = [
  {
    path: 'contact-temp-new',
    component: ContactTempPopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.contactTemp.home.title'
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup'
  },
  {
    path: 'contact-temp/:id/edit',
    component: ContactTempPopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.contactTemp.home.title'
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup'
  },
  {
    path: 'contact-temp/:id/delete',
    component: ContactTempDeletePopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.contactTemp.home.title'
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup'
  }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/contact-temp/contact-temp.route.ts